export const EMAIL = 'EMAIL';
export const SMS = 'SMS';
export const CALL = 'CALL';
export const POSTCARD = 'POSTCARD';